import { useAtomValue } from 'jotai';
import { useTranslation } from 'next-i18next';

import { Heading } from '@restworld/ui-ds-base';

import { workerPastExperiencesAtom } from '../../../../employer-job-listing.atoms';
import { TabCardWrapper } from '../candidate-profile-section';
import { WorkerExperienceItem } from './worker-experience-item';
import { StyledSeparator } from './worker-experience';

export const WorkerExperiencesSection = () => {
  const workerPastExperiences = useAtomValue(workerPastExperiencesAtom);
  const itemsCount = workerPastExperiences?.length || 0;
  const { t } = useTranslation('onboarding-page');
  const errorMessage = t('missing_info');

  return (
    <TabCardWrapper title={t('experiences')}>
      {workerPastExperiences?.map((workerPastExperience, index) => (
        <div className="w-full" key={index} id={`work_experience-${index}`}>
          <WorkerExperienceItem workerPastExperience={workerPastExperience} key={index} experienceIndex={index} />
          {index < itemsCount - 1 && <StyledSeparator />}
        </div>
      ))}
      {!workerPastExperiences?.length && (
        <Heading size={5} weight="normal" color="muted">
          {errorMessage}
        </Heading>
      )}
    </TabCardWrapper>
  );
};
